import type { ReactNode } from "react";
import { EmptyRow, ErrorRow, NoResultsRow, SkeletonRows } from "./DataTableStates";
import type { Column, DataTableEmpty } from "./DataTableTypes";
import type { BodyState } from "./rowState";

interface DataTableBodyProps<R> {
  state: BodyState;
  columns: Column<R>[];
  skeletonRows: number;
  error: DataTableEmpty | null | undefined;
  empty: DataTableEmpty | undefined;
  /** Clears the search and filters, from the "No results" message. */
  onClearSearch: () => void;
  /** The page's rows, shown in the "rows" state. */
  children: ReactNode;
}

/** Table body: placeholders, a message, or the rows, depending on the state. */
export function DataTableBody<R>(props: DataTableBodyProps<R>): React.JSX.Element {
  return <tbody>{bodyContent(props)}</tbody>;
}

function bodyContent<R>({ state, columns, skeletonRows, error, empty, onClearSearch, children }: DataTableBodyProps<R>): ReactNode {
  const colSpan = columns.length;
  switch (state) {
    case "loading":
      return <SkeletonRows columns={columns} count={skeletonRows} />;
    case "error":
      return error ? <ErrorRow colSpan={colSpan} error={error} /> : null;
    case "empty":
      return <EmptyRow colSpan={colSpan} empty={empty} />;
    case "noResults":
      return <NoResultsRow colSpan={colSpan} onClear={onClearSearch} />;
    case "rows":
      return children;
  }
}
